import { connect } from "socket.io-client";
import { store } from "../../../store/store";
import { ScreenRoute } from "../../constants/ScreenRouteConstant";
import { updateChemistData, updateGuestToken, updateLoginStatus, updateTokenInfo } from "../redux/commonRedux";
import { CacheDataToRefresh, WebSocketMessageSubscription } from "../subject-behaviour/CommonRxjsService";
import { clearCartData } from "../oms/OMSCartUtils";
import { isObjectNotEmpty } from "../CommonUtils";
import { doPost as APIPost } from '../api/API';
import { NavigateToAppBaseScreen } from "../NavigationUtils";
import { getSelectedChemistStoreId } from "../chemist/ChemistStoreUtils";
import { moeAddUserAttribute } from "./MoengageUtils";

import RefreshCacheAction from "./RefreshCache";

export var pendingNavigation = null;
export var onAppLoadExecutedOnce = false;

const loadFullAppNavigation = () => {
    pendingNavigation = (navigation) =>
        navigation.replace(ScreenRoute.dashboard_screen)
}

export const initialiseAppDataAPI = () => {
    const reduxState = store.getState();
    const chemistStoreLoaded = localStorage.getItem('storeProfileLoaded') ? true : false
    let refreshList = []
    if (chemistStoreLoaded) {
        refreshList.push({
            name: RefreshCacheAction.refreshChemistStoreData,
            requestData: { rcbElementRef: null }
        })
        refreshList.push({
            name: RefreshCacheAction.refreshUserProfileData,
            requestData: { pharmacyId: getSelectedChemistStoreId(reduxState) }
        })
    } else {
        refreshList.push({
            name: RefreshCacheAction.refreshUserProfileData,
            requestData: { getVisitedStores: true }
        })
    }
    if (reduxState.isUserLogin) {
        if (chemistStoreLoaded)
            refreshList.push({
                name: RefreshCacheAction.refreshOrderAndEconsultData,
                requestData: { fetchOrders: true }
            })
        else refreshList.push({
            name: RefreshCacheAction.refreshOrderAndEconsultData,
            requestData: { fetchConsultations: true }
        })
    }
    CacheDataToRefresh.setRefreshList(refreshList)
}

const loadDeepLinkData = () => {
    var deeplinkData: any = null;
    if (__DEV__ && window['APP_DEEPLINK_DATA'] == '$DEEPLINK_DATA' ||
        window['APP_DEEPLINK_DATA'] == '') {
        if (__DEV__ && location.host == 'medicals.mcords.co.in') {
            // copy guestTokenInformation from https://ops.mcords.co.in/cleanup_data_state?purpose=cgt
            deeplinkData = {
                "pharmacyId": 4126, "route": "pharmacy_profile",
                "pharmacyName": "Dd Medical Store 987",
                "guestTokenInformation": {
                    "token": "WI6DUFVMz7Bm4cqL5W4/gcd8w1TaMHZNHYyiSIlJF%2BEfM74J6ofwRw5zDxyq6vZY2boU06LqV4syAoIQZ6V7UphgXWTFk80f2A9QIJVBZ%2B9BcXoDQbUtt0mRH%2By7nlNjmv34q6YBxQ/pqL9IYIu9xQbphMMCwvORTcUmZ5DWMrJX62mf8foycUTVygXZ0sgL47RKQEZuXJht5%2BHJa9eIiGISgWE/O%2Bvn3wVUr9LhjHdIeE2k1M/WWTm7VVXc%2BkRdLyLcaj0hDNmkyvrWnKpwf07j%2B22MjaKfF1hAzbZAoOMzKpb7QGqtJdoTNbngPC7dzuDBq6H2fhJ3HzgZnkb9nMCT0PCzxeskOQL5MBYMlPkJAqlVpcT4%2BMQCKjxBNOjG",
                    "expiresAt": 1686982320,
                    "gpToken": "MPxN%2BuWlkf8VVrgF2f9rdUhN09n8Z54wcYI7f7H5MKlc9wWwLYgTQAJ78lCdxBWEPZIMz4yGN8DFrx6lUSEaVn48dLmmzlujul6ZNQtRE11AQRFLzmKwPqT7H%2Bo5dM7D%2BgGqusNiddUWWnQcpBLHYQbJgG9NHEIHzw/LOrNJRPU%3D"
                }
            }
        } else {
            console.log('not manipuliating deeplink data for local testing')
        }
    } else if (window['APP_DEEPLINK_DATA']) {
        localStorage.removeItem('deeplinkData')
        deeplinkData = JSON.parse(atob(window['APP_DEEPLINK_DATA']));
        window['APP_DEEPLINK_DATA'] = '';
    }

    const reduxState = store.getState();
    if (!reduxState.isUserLogin && isObjectNotEmpty(deeplinkData?.guestTokenInformation)) {
        updateGuestToken(deeplinkData.guestTokenInformation);
    }

    if (deeplinkData && deeplinkData['loadFullApp']) {
        localStorage.setItem('storeProfileLoaded', '');
        localStorage.removeItem('profileDeeplinkData');
        updateChemistData({});
        loadFullAppNavigation();
        return;
    }

    // reset deeplink if route is not defined.
    if (deeplinkData && !deeplinkData['route']) {
        deeplinkData = null;
    }
    if (reduxState.isUserLogin && deeplinkData && deeplinkData['route'] === ScreenRoute.oms_message_view) {
        localStorage.setItem('deeplinkData', JSON.stringify(deeplinkData));
        pendingNavigation = (navigation) => {
            navigation.replace(ScreenRoute.oms_message_view, {
                orderData: {
                    oid: deeplinkData?.['orderId'],
                    pharmacyData: { id: deeplinkData?.['pharmacyId'] }
                }
            });
        }
    } else if (reduxState.isUserLogin && deeplinkData && deeplinkData['route'] === ScreenRoute.view_order_summary) {
        localStorage.setItem('deeplinkData', JSON.stringify(deeplinkData));
        pendingNavigation = (navigation) => {
            navigation.replace(ScreenRoute.view_order_summary, { orderId: deeplinkData?.['orderId'] });
        }
    } else if (deeplinkData || localStorage.getItem('profileDeeplinkData')) {
        let localDeepLinkData: any = deeplinkData;
        if (deeplinkData) {
            if (localStorage.getItem('profileDeeplinkData')) {
                let localDeepLinkData: any = localStorage.getItem('profileDeeplinkData');
                localDeepLinkData = JSON.parse(localDeepLinkData);
                if (deeplinkData?.pharmacyId !== localDeepLinkData?.pharmacyId) {
                    clearCartData(); updateChemistData({})
                }
            } else {
                clearCartData(); updateChemistData({})
            }
            if (deeplinkData?.tokenInformation) {
                updateTokenInfo(deeplinkData.tokenInformation);
                updateLoginStatus(true);
            }
        } else {
            localDeepLinkData = localStorage.getItem('profileDeeplinkData');
            localDeepLinkData = JSON.parse(localDeepLinkData);
        }
        if (localDeepLinkData?.pharmacyName) {
            document.title = localDeepLinkData?.pharmacyName ?? 'Order from store';
        }
        if (deeplinkData?.pharmacyId) {
            moeAddUserAttribute('site_pid_v2', deeplinkData.pharmacyId)
            moeAddUserAttribute('site_name', localDeepLinkData.pharmacyName)
            localStorage.setItem('profileDeeplinkData', JSON.stringify(deeplinkData));
            localStorage.setItem('storeProfileLoaded', 'true')
        }
        pendingNavigation = (navigation) => navigation.replace(ScreenRoute.tab_controller_screen);
    } else loadFullAppNavigation()
}

const initWebSocketConnection = (_wssArgs: any = null) => {
    //check If connectiopnOpen
    if (!_wssArgs) return;
    // if (isSocketIoConnected) return;
    var _socket = connect(_wssArgs['endpoint'], {
        transports: ['websocket'], 'query': _wssArgs['query'], reconnection: false,
        forceNew: false, reconnectionDelay: 10000, autoConnect: false, reconnectionAttempts: 3,
        reconnectionDelayMax: 10000
    });
    _socket.on("connect", () => {
        console.log("connect", _socket.id); // x8WIv7-mJelg7on_ALbx
    });
    _socket.on('connectAck', (data) => {
        console.log("connectAck", _socket.id, data); // undefined
    })
    _socket.on("/oms/order_updated", (data) => {
        // called for each packet received
        WebSocketMessageSubscription.setWebSocketMessage(data)
    });
    _socket.on("disconnect", (reason) => {
        setTimeout(initWSS, 3000);
        console.log("disconnect", reason); // undefined
    });
    _socket.connect();
}

const initWSS = () => {
    const reduxState = store.getState();
    if (!reduxState.isUserLogin) {
        return;
    }
    APIPost('misc/wss_token', {}).then((response: any) => {
        if (response) {
            initWebSocketConnection(response);
        }
    }, (err: any) => { console.log("API is failed with error " + err) })
}


export const executePendingNavigation = (navigation, refreshAppData=false) => {
    if (refreshAppData)
        initialiseAppDataAPI()

    if (pendingNavigation) {
        pendingNavigation(navigation);
        pendingNavigation = null;
    } else NavigateToAppBaseScreen(navigation)

}

export const onAppLoad = () => {
    if (onAppLoadExecutedOnce) return;
    onAppLoadExecutedOnce = true;
    loadDeepLinkData()
    initialiseAppDataAPI()
    initWSS()
}
